import { core }       from '../../../api/api-endpoints.js'
import {
  ACTIONS,
  STATUS_ACTIVE,
  STATUS_NOT_ACTIVE,
  STATUS_PLANED,
  StorageId,
  TransportationId,
  WALL
}                     from '../../../config/config.js'
import formBaseMixin  from '../../../components/form/form-base-mixin.js'
import {
  tko
}                     from '../../../api/api-endpoints'
import {
  tkoOffline
}                     from '../../../api/api-offline-endpoints.js'
import year           from '../../../utils/year'
import userFriendlyEr from '../../../utils/userFriendlyEr'
import url            from '../../../utils/url'
import {
  ProcessingId,
  ProcessingNoTkoId,
  TARIFFS_TKO_OBJECT
}                     from '../../../config/config'
import documentsMixin from '@/common/layout/documents/documentsMixin'

const TkoObjectIngroro = () => {
  return {
    id:           null,
    number:       '',
    dt:           '',
    groro_number: ''
  }
}

const TkoObjectExpertize = () => {
  return {
    id:           null,
    number:       '',
    dt:           '',
    organization: ''
  }
}

export default {
  mixins: [formBaseMixin, documentsMixin],
  data() {
    return {
      tabView:                     'tab1',
      showFullOperatorSelectTable: false,
      checkedFullOperator:         null,
      fields:                      {
        id:                    null,
        object_date_start:     '',
        object_date_finish:    '',
        status_id:             '',
        coordinates:           '0,0',
        latitude:              '',
        longitude:             '',
        address_id:            '',
        tko_operator_id:       '',
        address:               '',
        source_id:             '',
        tkoOperatorName:       '',
        tkoActions:            [],
        garbage_groups:        [],
        road_types:            [],
        has_monitoring:        0,
        has_doc_building:      0,
        has_doc_recultivation: 0,
        engineering_systems:   [],
        close_date:            '',
        full_operator:         null,
        is_intermunicipal:     false,
        is_mps:                false,
        tkoObjectIngroro:      new TkoObjectIngroro(),
        tkoObjectExpertize:    new TkoObjectExpertize(),
        has_expertise:         0,
        has_groro:             0,
        tkoObjectTariffs:      [],
        photo_id:              null,
        post_address:          null
      },
      leftoverCapacityYear:        {},
      leftCapacityYearCurrent:     { id: null, name: null, year: new Date().getFullYear() },
      registrationDocumentsModel:  {
        1: {
          number:      '',
          date_start:  '',
          date_finish: ''
        },
        2: {
          number:      '',
          date_start:  '',
          date_finish: ''
        },
        3: {
          number:      '',
          date_start:  '',
          date_finish: ''
        },
        4: {
          number:      '',
          date_start:  '',
          date_finish: ''
        }
      }
    }
  },
  title: function() {
    if (this.$route.params && this.itemId) {
      if (this.userCanEdit && this.editDisabled === false) {
        return 'Редактирование записи'
      }
      return 'Просмотр записи'
    } else {
      return 'Добавление новой записи'
    }
  },
  created() {
    if (this.isEditOnMap) {
      // disable reload in tabs
      this.$store.commit('skipAsyncData', { name: this.$route.name, value: true })
    }
    this.setBreadcrumbs()
    const currentLeftoverCapacityYear = this.yearCollection[this.yearCollection.length - 1]
    this.leftCapacityYearCurrent      = Object.assign({}, this.leftCapacityYearCurrent, currentLeftoverCapacityYear)
    this.yearCollection?.map(({ name }) => !this.leftoverCapacityYear?.[name] &&
      this.$set(this.leftoverCapacityYear, name, {
        leftover_capacity: null, id: null, tko_object_id: this.item?.id ?? null
      })
    )
  },
  watch:    {
    'fields.is_intermunicipal': function(checked) {
      if (checked) {
        this.fields.is_mps = false
      }
    },
    'fields.is_mps':            function(checked) {
      if (checked) {
        this.fields.is_intermunicipal = false
      }
    },
    'fields':                   {
      handler: function() {
        this.recalc()
      },
      deep:    true
    }
  },
  computed: {
    leftovers() {
      return this.years.map(y => ({ year: y.name }))
    },
    TARIFFS() { return TARIFFS_TKO_OBJECT },
    editDisabled() { return this.objectFormDisabled },
    hideDeleteButton() {
      return !!(this.isEditOnMap &&
        this.fields?.id &&
        +this.fields?.status_id !== STATUS_PLANED ||
        this.fields?.id)
    },
    showSaveButton() { return !(this.isEditOnMap && +this.fields?.status_id !== STATUS_PLANED) },
    statusDisabled() { return !!(this.isFieldDisabled('status_id') || this.isEditOnMap && this?.fields?.id)},
    disableEditGroro() { return this.editDisabled || this.fields.has_groro < 1 },
    disableEditExpertize() { return this.editDisabled || this.fields.has_expertise < 1 },
    objectFormDisabled() { return this.isEditOnMap && this?.item?.status?.id === STATUS_ACTIVE },
    yeasOrNo() { return [{ id: 1, name: 'Имеется' }, { id: 0, name: 'Отсутствует' }] },
    notActive() { return STATUS_NOT_ACTIVE },
    isEditOnMap() {
      return !!(this.$route.name.indexOf('geo.tread') > -1 || this.$route.name.indexOf('geo.forecast') > -1)
    },
    years() { return year.getSpecifiedYearsOptions(2013, 2050) },
    yearCollection() { return this.collection?.year || [] },
    operationYear() { return year.getSpecifiedYearsOptions(1950, 2050) },
    ACTIONS() { return ACTIONS },
    collection() { return this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint()) },
    statuses() { return this.collection?.status || [] },
    garbageGroupsOptions() { return this.collection?.garbage_group || [] },
    engineeringSystemOptions() { return this.collection?.engineering_system || [] },
    specOfAccessRoadsOptions() { return this.collection?.road_type || [] },
    tkoObjectTypeOptions() { return this.collection?.tko_object_type || [] },
    tkoObjectStateOptions() { return this.collection?.tko_object_state || [] },
    tkoOperators() { return this.$store.getters.readUrlEndpoint(this.getTkoOperatorEndpoint())?.tko_operator || [] },
    documents() { return this.$store.getters.readUrlEndpoint(this.getDocumentsEndpoint(this.itemId)) || [] },
    fullOperatorTypes() {
      return [{ id: 'operator', name: 'Оператор' }, { id: 'regOperator', name: 'Региональный оператор' }]
    },
    StorageId() { return StorageId },
    ProcessingId() { return ProcessingId },
    ProcessingNoTkoId() { return ProcessingNoTkoId },
    TransportationId() { return TransportationId },
    isUnauth() { return this.$route?.name?.includes('unauthorized.wpf') }
  },
  methods:  {
    fileUploaded({ id }) { this.fields.photo_id = id },
    fileRemoved() { this.fields.photo_id = null },
    uploadUrl() { return core.file() },
    setBreadcrumbs() {
      let links = []
      switch (this.$route.name) {
        case 'registry.operators.update.objectUpdate':
        case 'registry.operators.create.objectUpdate':
        case 'registry.regionalOperators.update.objectUpdate':
          links.push({ name: 'registry.objects', meta: { title: 'Реестр объектов по обращению с отходами' } })
          break
      }
      if (links?.length) {
        this.$store.commit('breadcrumbs', { name: this.$route.name, links })
      }
    },
    getOperatorRoute(fullOperatorInfo) {
      let prevRoute = url.getRoute(this.$route, true)
      return {
        name:   (fullOperatorInfo.is_regional
          ? 'registry.regionalOperators.update'
          : 'registry.operators.update'),
        params: { id: fullOperatorInfo.id },
        query:  { prevRoute }
      }
    },
    
    transformFieldsBeforeSend() {
      this.fields.is_unauth = this.isUnauth
      this.fields.tariffs   = this.getTariffsArr()
    },
    // see: https://redmine.etton.ru/issues/13144
    additionalValidate: async function() {
      this.fields._afterSaveRouteTo = null
      if (this.isUnauth) {
        this.$bar.finish()
        await new Promise((resolve, reject) => {
          this.confirmBox(
            'Вы создали несанкционированный объект по обращению с отходами (хранение/захоронение без ГРОРО).',
            'Добавить его в раздел несанкционированных ОРО?',
            'Добавить'
          ).then(() => {
            this.fields._afterSaveRouteTo = 'unauthorized.wpf'
            this.fields.is_unauth         = true
            this.$bar.start()
            resolve()
          }).catch(() => {
            reject()
          })
        })
      }
      return true
    },
    // calc
    recalc() {
      let operationPeriod = this.fields.leftover_capacity / this.fields.power
      if (!isNaN(operationPeriod) && isFinite(operationPeriod)) {
        this.$set(this.fields, 'operation_period', operationPeriod.toFixed(1))
      } else {
        this.$set(this.fields, 'operation_period', 0.0)
      }
    },
    getEarlyCheckedFullOperator() {
      return { operator: this.fields.tko_operator_id, regOperator: this.fields.tko_operator_id }
    },
    deleteFullOperator() {
      this.$e.confirmBox('', 'Убрать эксплуатирующую организацию?', 'Да').then(() => {
        this.$set(this.fields, 'tko_operator', null)
        this.$set(this.fields, 'tko_operator_id', null)
        this.$forceUpdate()
      })
    },
    endpointFullOperatorList(ctx) {
      let route = { query: { 'per-page': 50 } }
      
      if (ctx?.q) {
        route.query.q = ctx.q
      }
      
      if (ctx?.paginateObj) {
        route.query = Object.assign(route.query, ctx.paginateObj)
      }
      
      let result = { url: null, fields: { name: { label: 'Название' } } }
      
      if (ctx.currentListType === 'operator') {
        result.url = tko.operators(route)
      } else if (ctx.currentListType === 'regOperator') {
        result.url = tko.regionalOperators(route)
      }
      return result
    },
    fullOperatorUpdate($event) {
      let { checked, checkedModels } = $event
      this.checkedFullOperator       = Object.assign({}, this.checkedFullOperator, checked)
      this.checkedFullOperatorModels = Object.assign({}, this.checkedFullOperatorModels, checkedModels)
    },
    saveFullOperator() {
      if (this.$refs.fullOperatorSelectTable) {
        try {
          let type = this.$refs.fullOperatorSelectTable.currentListType
          this.$set(this.fields, 'tko_operator_id', this.checkedFullOperator[type])
          this.$set(this.fields, 'tko_operator', this.checkedFullOperatorModels[type][this.fields.tko_operator_id])
          this.showFullOperatorSelectTable = false
        } catch (e) {
          console.error(e)
          this.$e.errorBox(e)
        }
      }
    },
    prepareFieldsForSend(fields) {
      // get deep copy for prevetn crash in tkoObject...
      // after wrong server validation
      fields                    = JSON.parse(JSON.stringify(fields))
      fields.garbageGroups      = fields.garbage_groups
      fields.engineeringSystems = fields.engineering_systems
      fields.roadTypes          = fields.road_types
      
      // see: https://redmine.etton.ru/issues/12455
      if (!fields.has_groro) {
        fields.tkoObjectIngroro = null
      }
      delete fields.has_groro
      
      if (!fields.has_expertise) {
        fields.tkoObjectExpertize = null
      }
      
      const leftoverCapacityYear = Object.fromEntries(
        Object.entries(this.leftoverCapacityYear).filter(([undefined, { leftover_capacity }]) => !!leftover_capacity)
      )
      fields                     = Object.assign({}, this.fields, {
        ...(Object.keys(leftoverCapacityYear)?.length) && {
          leftoverCapacityYear: Object.entries(leftoverCapacityYear).map(
            ([year, leftoverCapacityObj]) => ({ ...leftoverCapacityObj, year })
          )
        }
      })
      
      if (fields?.address_id === '') {
        delete fields.address_id
      }
      
      if (fields?.tko_operator_id === '') {
        delete fields.tko_operator_id
      }
      
      return fields
    },
    initFieldsAfterLoad() {
      if (this.item) {
        let copy = Object.assign({}, this.item)
        if (!copy.tkoObjectIngroro) {
          copy.tkoObjectIngroro = new TkoObjectIngroro()
        }
        if (!copy.tkoObjectExpertize) {
          copy.tkoObjectExpertize = new TkoObjectExpertize()
        }
        this.fields = Object.assign({
                                      close_date:         '',
                                      tkoObjectIngroro:   new TkoObjectIngroro(),
                                      tkoObjectExpertize: new TkoObjectExpertize()
                                    }, copy)
        
        this.fields.status_id  = +this.fields.status.id
        this.fields.close_date = ''
        
        // https://redmine.etton.ru/issues/13143
        if (this.fields.operation_period && !isNaN(+this.fields.operation_period)) {
          this.fields.operation_period = (+this.fields.operation_period).toFixed(1)
        }
        
        if (this.fields.garbage_groups) {
          this.fields.garbage_groups = this.fields.garbage_groups.map(v => v.id)
        } else {
          this.fields.garbage_groups = []
        }
        if (this.fields.engineering_systems) {
          this.fields.engineering_systems = this.fields.engineering_systems.map(v => v.id)
        } else {
          this.fields.engineering_systems = []
        }
        if (this.fields.road_types) {
          this.fields.road_types = this.fields.road_types.map(v => v.id)
        } else {
          this.fields.road_types = []
        }
        
        if (this.fields.object_state) {
          this.fields.tko_object_state_id = this.fields.object_state.id
        }
        if (this.fields.object_type) {
          this.fields.tko_object_type_id = this.fields.object_type.id
        }
        
        this.fields.has_monitoring        = +this.fields.has_monitoring
        this.fields.has_doc_building      = +this.fields.has_doc_building
        this.fields.has_doc_recultivation = +this.fields.has_doc_recultivation
        
        if (this.fields.actions) {
          this.fields.tkoActions = this.fields.actions.map(v => v.id)
        } else {
          this.fields.tkoActions = []
        }
        console.log(this.fields)
        if (!this.item.hasOwnProperty('has_expertise')) {
          if (this.fields.object_expertize) {
            this.fields.has_expertise      = 1
            this.fields.tkoObjectExpertize = this.fields.object_expertize
          } else {
            this.fields.has_expertise = 0
          }
        } else {
          if (!this.fields.tkoObjectExpertize) {
            this.fields.tkoObjectExpertize = this.fields.object_expertize
          }
        }
        if (this.fields.object_ingroro) {
          this.fields.has_groro        = 1
          this.fields.tkoObjectIngroro = this.fields.object_ingroro
        } else {
          this.fields.has_groro = 0
        }
        
        this.fields.specOfAccessRoads = []
        
        if (this.isUnauth) {
          this.$set(this.fields, 'is_unauth', true)
        }
        
        if (this.documents && this.documents.data) {
          this.documents.data.forEach(v => {
            if (v.order) {
              this.registrationDocumentsModel[v.order] = v
            }
          })
        }
        this.initLeftoverCapacityYear()
        // for vue set get/set on fields
        this.fields = Object.assign({}, this.fields)
      }
      
      this.$store.dispatch('disableForm', {
        name:    this.$route.name,
        disable: this.objectFormDisabled
      })
    },
    initLeftoverCapacityYear() {
      if (this.item?.leftoverCapacityYear?.length) {
        this.item.leftoverCapacityYear.map(({ id, leftover_capacity, year, tko_object_id }) =>
                                             this.$set(this.leftoverCapacityYear, `${year}`, { id, leftover_capacity, tko_object_id })
        )
      }
      if (this.item?.currentLeftoverCapacityYear) {
        const yearIndex = this.yearCollection?.findIndex(
          ({ year }) => +year === +this.item.currentLeftoverCapacityYear.year
        )
        if (yearIndex !== -1) {
          const currentLeftoverCapacityYear = this.yearCollection[yearIndex]
          this.leftCapacityYearCurrent      = Object.assign({}, this.leftCapacityYearCurrent, currentLeftoverCapacityYear)
        }
      }
    },
    onSuccessDelete(r) {
      this.$swal({
                   position:          'center',
                   type:              'success',
                   title:             'Запись удалена',
                   showConfirmButton: false,
                   timer:             WALL.SUCCESS_TIMEOUT
                 })
      
      let route = this.getRedirectParams()
      route.query || (route.query = {})
      delete route.query.sort
      if (this.isEditOnMap) {
        this.$store.commit('skipAsyncData', { name: this.$route.name, depth: 1, value: false })
        this.$router.push(route, () => {
          // after succes, full map data reload
          this.$emitter.emit('geo.mapRefresh', {
            component: 'object-update',
            action:    'delete',
            response:  r
          })
        })
      } else {
        this.$router.push(route)
      }
    },
    onSuccess() {
      this.$swal({
                   position:          'center',
                   type:              'success',
                   title:             'Запись сохранена',
                   showConfirmButton: false,
                   timer:             WALL.SUCCESS_TIMEOUT
                 })
      this.unFreezeFrom()
      
      if (this.isEditOnMap) {
        let marketId = this.fields.id + 'tko'
        let route    = this.getRedirectParams()
        route.query || (route.query = {})
        delete route.query.sort
        route.query.openedPopupInfo = marketId
        this.$store.commit('skipAsyncData', { name: this.$route.name, depth: 1, value: false })
        this.$router.push(route, () => {
          this.$emitter.emit('geo.mapSetView', {
            lat:             this.fields.latitude,
            lng:             this.fields.longitude,
            zoom:            10,
            openedPopupInfo: marketId,
            refreshMap:      true
          })
        })
      } else {
        // https://redmine.etton.ru/issues/13144
        let redirectRoute = this.getRedirectParams()
        if (this.fields?._afterSaveRouteTo) {
          redirectRoute.name = this.fields?._afterSaveRouteTo
        }
        this.$router.push(redirectRoute)
      }
    },
    getEditablesEndpointsAndUrl() {
      let postUrl      = []
      let tmpEndpoints = []
      // add tech table
      // set first for create tech relation (need in garbage table, product section)
      postUrl.push(tko.objectTechOperationPost(this.fields.id))
      tmpEndpoints.push(tkoOffline.objectTechTable(this.$route.name))
      
      // garbages
      let years      = year.getYears()
      let operations = ['input', 'output', 'detail', 'product']
      for (let i = 0; i < years.length; i++) {
        for (let j = 0; j < operations.length; j++) {
          postUrl.push(tko.objectGarbageOperationPost({
                                                        query: {
                                                          sourceId: this.fields.id,
                                                          year:     years[i],
                                                          type:     operations[j]
                                                        }
                                                      }))
          tmpEndpoints.push(tkoOffline.objectGarbageTable(this.$route.name, years[i], operations[j]))
        }
      }
      
      return { postUrl, tmpEndpoints }
    },
    // TODO: refactor that
    afterSave: async function() {
      let promises = []
      let errors   = []
      if (this.fields.id) {
        for (let key in this.registrationDocumentsModel) {
          let doc         = this.registrationDocumentsModel[key]
          // TODO type of doc
          doc.order       = key
          doc.entity_id   = this.fields.id
          doc.entity_name = 'tko_object'
          
          let storeActionName = (doc.id ? 'updateModel' : 'createModel')
          
          promises.push(this.$store.dispatch(storeActionName, {
            url:  core.documentUpdateOrCreate(doc.id),
            data: doc
          }))
        }
      }
      
      if (!this.itemId) {
        let { postUrl, tmpEndpoints } = this.getEditablesEndpointsAndUrl()
        
        for (let i = 0; i < tmpEndpoints.length; i++) {
          if (this.$store.getters.readUrlEndpoint(tmpEndpoints[i])) {
            let data = this.$store.getters.readUrlEndpoint(tmpEndpoints[i]).data
            for (let j = 0; j < data.length; j++) {
              if (data[j]._isValid === true && data[j]._considerSaved === true) {
                try {
                  await this.$store.dispatch('createModel', {
                    url:      postUrl[i],
                    endpoint: tmpEndpoints[i],
                    data:     data[j]
                  })
                } catch (e) {
                  console.log(e)
                  errors.push(userFriendlyEr.recognize(e))
                }
              } else {
                console.warn('Invalid row', data[j])
              }
            }
          }
        }
        
        if (errors.length > 0) {
          console.log(errors)
          return Promise.reject(errors.join('<br><br>'))
        }
      }
      
      if (promises.length > 0) {
        try {
          await Promise.all(promises)
          
          Promise.resolve(1)
        } catch (e) {
          console.error(e)
          return Promise.reject(e)
        }
      }
      return Promise.resolve(1)
    },
    getTariffsArr() {
      return this.$refs.tkoTariff.getTariffsArr()
    }
  },
  asyncData({ store, route, fromRoute, methods }) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', { endpoint: methods.getItemEndpoint(route, fromRoute) }))
    }
    
    promises.push(store.dispatch('updateUrlEndpoint', { endpoint: methods.getCollectionEndpoint(), fromCache: true }))
    
    let itemId = route.params.id || route.params.objectId || null
    if (itemId) {
      promises.push(store.dispatch('updateUrlEndpoint', { endpoint: methods.getDocumentsEndpoint(itemId) }))
    }
    
    if (promises.length === 0) {
      return Promise.resolve(1)
    }
    
    return Promise.all(promises)
  }
}

